import React, { Component } from "react"
import { Query, Mutation } from "react-apollo"
import ApolloQueryHandler from "../../shared/apolloQueryHandler"
import GET_PAGE from "../../graphql/getPage.graphql"
import { Helmet } from "react-helmet"
import TsisETSDrillDown from "../../components/TsisETSDrillDown"
import VennDetails from "../../components/VennDetails"
import Modal from "../../components/Modal"
import RequestAccessModal from "../../components/RequestAccessModal"
import { Redirect } from "react-router"
import moment from "moment"
import qs from "qs"
import SharedInsightsProductDetails from "../../components/SharedInsightsProductDetails"

import REQUEST_REPORT_ACCESS from "../../graphql/requestReportAccess.graphql"
import { DEFAULT_LOGO } from "../../shared/constants"
import { MetaData, structureProductData } from "../../shared/structureData"

import Loading from "../../components/Loading"

import "./productDetails.scss"

class ProductDetails extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isModalOpen: false,
      requestAccessSuccess: false,
    }
  }

  closeModal = () =>
    this.setState({ isModalOpen: false, requestAccessSuccess: false })

  requestAccess = ({ first, last, time, ...args }) => {
    let { name, id, proprietaryDataset } = this.props.data.page
    this.props
      .requestAccess({
        variables: {
          productId: this.props.data.page.id,
          name: `${first} ${last}`,
          time: moment(time, "HH:mm").utc().format("HH:mm"),
          ...args,
        },
      })
      .then(({ data }) => {
        if (data.requestAccessToProduct.payload === "success") {
          this.props.trackEvent("Requested access to product", {
            productName: name,
            productId: id,
            productType: proprietaryDataset,
          })
          this.setState({ requestAccessSuccess: true })
        } else {
          alert(
            `Unable to process your request: ${data.requestAccessToProduct.message}`
          )
        }
      })
      .catch(() => alert("Unable to process your request"))
  }

  download = (item) => (e) => {
    let { isSpecialAccess, files, name, id, proprietaryDataset, free } =
      this.props.data.page

    if (!isSpecialAccess && !free) {
      e.preventDefault()
      alert("You have not purchased this report!")
    } else if (!files || !files[item || 0]) {
      e.preventDefault()
      alert("This report is not yet available to download")
    } else {
      this.props.trackEvent("Downloaded report", {
        productName: name,
        productId: id,
        productType: proprietaryDataset,
        file: files && files[item || 0].name,
      })
    }
  }

  view = (item) => {
    let { isSpecialAccess, files, name, id, proprietaryDataset, free } =
      this.props.data.page

    if (!isSpecialAccess && !free) {
      alert("You have not purchased this report!")
    } else if (!files || !files[item || 0]) {
      alert("This report is not yet available to view")
    } else {
      this.props.trackEvent(" Clicked View report", {
        productName: name,
        productId: id,
        productType: proprietaryDataset,
        file: files && files[item || 0].name,
      })

      this.props.history.push({
        pathname: this.props.location.pathname + "/view",
        search: item && qs.stringify({ item }, { addQueryPrefix: true }),
      })
    }
  }

  componentDidMount = () => {
    let { id, name, proprietaryDataset } = this.props.data.page
    this.props.trackPage("Product Details", {
      productName: name,
      productId: id,
      productType: proprietaryDataset,
    })
  }

  renderSEO = () => {
    let { name, description, type, image } = this.props.data.page
    let seo = {}
    seo.url = type
      ? `https://app.etr.ai/${type.toLowerCase()}/${name.toLowerCase()}`
      : ""
    seo.title = `${name} | ETR`
    seo.image = image ? image : DEFAULT_LOGO //ER: RT: TODO: GET IMAGES FOR ALL SECTORS AND VENDORS
    seo.type = "product.group"
    seo.description = description
    seo.name = name

    return (
      <Helmet>
        {MetaData(seo)}
        <script type="application/ld+json">{structureProductData(seo)}</script>
      </Helmet>
    )
  }
  render() {
    if (!this.props.viewer || !this.props.viewer.isUserAuthenticated) {
      return (
        <Redirect
          to={{
            pathname: "/login",
            state: { from: this.props.location.pathname },
          }}
        />
      )
    }

    let { id, name, isForSale, proprietaryDataset, canRequestAccess } =
      this.props.data.page

    let eventBody = {
      productName: name,
      productId: id,
      productType: proprietaryDataset,
    }

    const onPurchaseClick = () => {
      if (canRequestAccess) {
        this.props.trackEvent("Clicked Request Report Access", eventBody)
        this.setState({ isModalOpen: true })
      }
    }

    let purchaseCardProps =
      isForSale && canRequestAccess
        ? {
            buttonText: "REQUEST ACCESS",
            description: "Request access to this report",
            buttonAction: onPurchaseClick,
          }
        : null

    let detailProps = {
      ...this.props,
      purchase: purchaseCardProps,
      download: this.download,
      view: this.view,
    }

    let details
    switch (proprietaryDataset) {
      case "ETS":
      case "TSIS":
      case "DataReport":
      case "DD":
      case "VEC":
        details = <TsisETSDrillDown {...detailProps} />
        break
      case "ObservatoryReport":
      case "IndustryAnalysis":
      case "VendorFocus":
        details = <SharedInsightsProductDetails {...detailProps} />
        break
      case "VENN": {
        const onRequestEventAccessClick = () =>
          this.props.trackEvent("Clicked Request Event Access", eventBody)
        const onRequestAccessSuccess = () =>
          this.props.trackEvent("Requested Event Access", eventBody)

        details = (
          <VennDetails
            onRequestEventAccessClick={onRequestEventAccessClick}
            onRequestAccessSuccess={onRequestAccessSuccess}
            {...detailProps}
          />
        )
        break
      }
      default:
        details = null
    }

    return (
      <div className="product-details-main-container">
        {this.renderSEO()}
        {details}
        <Modal
          isOpen={this.state.isModalOpen}
          close={this.closeModal}
          classes={["medium"]}
        >
          <RequestAccessModal
            close={this.closeModal}
            submit={this.requestAccess}
            success={this.state.requestAccessSuccess}
            successMessage="A member from our sales team will reach out to you shortly"
          />
        </Modal>
      </div>
    )
  }
}

const ProductDetailsWithData = (componentProps) => (
  <Query
    query={GET_PAGE}
    variables={{ slug: componentProps.match.params.product, type: "product" }}
    fetchPolicy="network-only"
  >
    {(queryProps) => {
      let { loading, error, data, fetchMore } = queryProps
      if (error) {
        console.log("product error: ", error)
        return null
      }

      if (loading) {
        return <Loading />
      }

      const loadMoreOnScroll = () =>
        fetchMore({
          variables: {
            starting_after:
              data.page.relatedProducts && data.page.relatedProducts.length > 0
                ? data.page.relatedProducts[
                    data.page.relatedProducts.length - 1
                  ].id
                : null,
          },
          updateQuery: (prev, { fetchMoreResult }) => {
            if (!fetchMoreResult) return prev

            return {
              ...prev,
              page: {
                ...prev.page,
                relatedProducts: [
                  ...prev.page.relatedProducts,
                  ...fetchMoreResult.page.relatedProducts,
                ],
              },
            }
          },
        })

      return (
        <ApolloQueryHandler {...queryProps} {...componentProps}>
          {(props) => (
            <Mutation mutation={REQUEST_REPORT_ACCESS}>
              {(mutate) => (
                <ProductDetails
                  {...props}
                  requestAccess={mutate}
                  loadMoreOnScroll={loadMoreOnScroll}
                />
              )}
            </Mutation>
          )}
        </ApolloQueryHandler>
      )
    }}
  </Query>
)

export default ProductDetailsWithData
